const SUPPORTED_LANG_CODES = ['fr', 'en', 'es', 'de', 'it', 'nl'];

/**
 * Normalise le code langue (ex. fr-FR, esp) vers un des codes supportés.
 * @param {string} [lang] - Code langue 
 * @returns {string} 
 */
export function getNormalizedLanguageCode(lang) {
  const raw = (lang || 'fr').split('-')[0].toLowerCase();
  const map = { esp: 'es', es: 'es', fr: 'fr', en: 'en', de: 'de', it: 'it', nl: 'nl' };
  return map[raw] && SUPPORTED_LANG_CODES.includes(map[raw]) ? map[raw] : 'fr';
}
